import React, {useState, useEffect, useRef} from 'react'
import { faPencil, faTrash, faArrowUp, faArrowDown, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import { sortById } from '../../utils/globalUtils';
import { topicData, setTopic, setTopicComponents } from '../../slices/topicSlice';
import { displayEditorUtil, displayTopicCompUtil, entryPoint } from '../../utils/topicUtils';
import { getTopicComponents, deleteTopicComponent, swapTopicComponentRank } from '../../utils/api-services/topic';
import Confirm from '../../global/components/Confirm';

const TopicComponentListItem = ({obj, index, edit}) => {

    const [confirm, setConfirm] = useState(false);
    const [hover, setHover] = useState(false);
    const [modal, setModal] = useState(false);
    const itemRef = useRef();

    const tpicData = useSelector(topicData);
    const dispatch = useDispatch();
    const topic = tpicData.topic;
    const topicComponents = tpicData.topicComponents;

    function handleHover(state){
        setHover(state);
    };

    function editItem(){
        showModal();
    }

    async function sortComponent(direction){
        let toIndex = 0;

        if(direction == "up"){ toIndex = index - 1; }
        else if(direction == "down"){ toIndex = index + 1; }
        const toObj = topicComponents[toIndex];

        const fromId = obj.Id
        const fromRank = obj.Rank
        const toId = toObj.Id;
        const toRank = toObj.Rank;

        const saveRecord = await swapTopicComponentRank({
            fromId: fromId,
            fromRank: fromRank,
            toId: toId,
            toRank: toRank
        });
                        
        if(saveRecord.Success){
            loadTopicComponents();
        }
    }

    const showModal = ()=>{
        setModal(true);
    }

    const closeModal = ()=>{
        setModal(false);
    }

    function confirmDelete(){
        setConfirm(true);
    }

    const deleteItem = async () => {
        const deleteRecord = await deleteTopicComponent({id: obj.Id}); 
        if(deleteRecord.Success){
            loadTopicComponents();
        }
    }

    const loadTopicComponents = async () => {
        const data = await getTopicComponents(obj.TopicSlug);
        dispatch(setTopicComponents(data));
    }

    const styles = {
        item: {
            background: hover?'#efefef':'#fff',
            margin: '10px 5px',
            padding:'3px 15px',
            border:'1px solid #404040',
            borderRadius:30,
         
            outline: 'none',
            boxShadow: 'none',
            transition: 'none',
        },
        body:{
            position: 'relative',
        },
        title:{
            color: '#404040',
            fontSize: 15,
            marginBottom: 0
        },
        actions: {
            container: {
                position: 'absolute',
                top: 0,
                right: -15
            },
            btn:{
                color: hover?'#00667d':'#888',
                background: hover?'#efefef':'#fff',
                padding: '7px 10px',
                border: 'none',
                borderRadius: 3,
                fontSize: 15,
                outline: 'none',
                boxShadow: 'none',
                transition: 'none',
            },
            option:{
                fontSize: 14,
            },
            optionRed:{
                color: '#ff6d6d',
                fontSize: 14,
            },
        },
    }

    const editorParams = {
        topic: topic,
        obj: obj,
        componentType: obj.ComponentType,
        editor: obj.Editor,
        containerId: obj.ContainerId,
        action: "edit",
        close: closeModal,
    }

    const confirmParams = {
        title: "Remove",
        info: "Do you want to remove?",
        confirm: confirm, 
        setConfirm: setConfirm, 
        action:deleteItem
    }

    function capFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function actions(){
        return(
            <div class="dropdown">
                <button type="button" data-toggle="dropdown" style={styles.actions.btn} onMouseEnter={()=>handleHover(true)} onMouseLeave={()=>handleHover(false)}>
                    <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                    <Link onClick={()=>{editItem()}} class="dropdown-item" style={styles.actions.option}>
                        <FontAwesomeIcon icon={faPencil} /> &nbsp;&nbsp;&nbsp;&nbsp; Edit
                    </Link>

                    {topicComponents[index - 1] &&
                        <>
                            <div className="dropdown-divider"></div>
                            <Link onClick={()=>{sortComponent("up")}} class="dropdown-item" style={styles.actions.option}>
                                <FontAwesomeIcon icon={faArrowUp} /> &nbsp;&nbsp;&nbsp;&nbsp; Move Up
                            </Link>
                        </>
                    }

                    {topicComponents[index + 1] &&
                        <>
                            <div className="dropdown-divider"></div>
                            <Link onClick={()=>{sortComponent("down")}} class="dropdown-item" style={styles.actions.option}>
                                <FontAwesomeIcon icon={faArrowDown} /> &nbsp;&nbsp;&nbsp;&nbsp; Move Down
                            </Link>
                        </>
                    }

                    <div className="dropdown-divider"></div>
                    <Link onClick={()=>{confirmDelete()}} class="dropdown-item" style={styles.actions.optionRed}>
                        <FontAwesomeIcon icon={faTrash} /> &nbsp;&nbsp;&nbsp;&nbsp; Delete
                    </Link>
                </div>
            </div>
        )
    }

    return (
        <div ref={itemRef}>

            <div style={styles.body}>
                {displayTopicCompUtil(obj, edit? entryPoint.edit: entryPoint.display)}
                {edit && <div style={styles.actions.container}>{actions()}</div>}
            </div>

            <Modal size='lg' show={modal} onHide={closeModal} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title style={{fontSize:15}}>{capFirstLetter(obj.ComponentType)} Editor</Modal.Title>
                    <button type="button" onClick={closeModal} className="close">&times;</button>
                </Modal.Header>
                <Modal.Body style={{padding:0}}>  
                    {displayEditorUtil(editorParams)}
                </Modal.Body> 
            </Modal>

            <Confirm params={confirmParams} />
            
        </div>
    )
}

export default TopicComponentListItem